import React from 'react';
import { clsx } from 'clsx';

export interface StackProps {
  direction?: 'vertical' | 'horizontal';
  spacing?: 1 | 2 | 3 | 4 | 6 | 8;
  align?: 'start' | 'center' | 'end' | 'stretch';
  justify?: 'start' | 'center' | 'end' | 'between';
  children: React.ReactNode;
  className?: string;
}

const spacingStyles = {
  vertical: {
    1: 'space-y-1',
    2: 'space-y-2',
    3: 'space-y-3',
    4: 'space-y-4',
    6: 'space-y-6',
    8: 'space-y-8',
  },
  horizontal: {
    1: 'space-x-1',
    2: 'space-x-2',
    3: 'space-x-3',
    4: 'space-x-4',
    6: 'space-x-6',
    8: 'space-x-8',
  },
};

const alignStyles = {
  start: 'items-start',
  center: 'items-center',
  end: 'items-end',
  stretch: 'items-stretch',
};

const justifyStyles = {
  start: 'justify-start',
  center: 'justify-center',
  end: 'justify-end',
  between: 'justify-between',
};

export function Stack({
  direction = 'vertical',
  spacing = 4,
  align = 'stretch',
  justify = 'start',
  children,
  className,
}: StackProps) {
  return (
    <div
      className={clsx(
        'flex',
        direction === 'vertical' ? 'flex-col' : 'flex-row',
        spacingStyles[direction][spacing],
        alignStyles[align],
        justifyStyles[justify],
        className
      )}
    >
      {children}
    </div>
  );
}
